import moment from 'moment';
import { API_URL } from '../../Config/Config';
import { apiGet, apiPatch, apiPost } from '../standardApi';

export async function apiGetMembers(token) {
  return await apiGet(
    `/Profile/GetProfile`,
    'application/json',
    token
  );
}
export async function apiSendCodeByEmail() {
  return await apiPost(
    `/Profile/SendCode`,
    JSON.stringify({}),
    'text/plain'
  );
}

export async function apiUpdatePassword(password) {
  return await apiPost(
    `/Profile/UpdatePassword`,
    JSON.stringify({
      password,
      currentPassword: 'Spviecgrm2024!@'
    }),
    'text/plain'
  );
}

export async function apiConfirmUpdatePassword(otpCode) {
  return await apiPost(
    `/Profile/ConfirmUpdatePassword`,
    JSON.stringify({
      otpCode
    }),
    'text/plain'
  );
}

export async function apiUpdateMainInsuredInfo({ name, birthdate, numSecu }) {
  return await apiPost(
    `/Profile/ModifyMainInsuredInfos`,
    JSON.stringify({
      name: name,
      birthDate: moment(birthdate, 'DD/MM/YYYY').format('YYYY-MM-DD'), 
      socialSecurityNumber: numSecu
    }),
    'application/json'
  );
}
export async function apiConfirmUpdateUserInfo(code) {
  return await apiPost(
    `/Profile/ConfirmBeneficiaryInfosUpdate`,
    JSON.stringify({
      otpCode: code
    }),
    'application/json'
  );
}

export async function apiConfirmBeneficiaryResiliation(otpCode) {
  return await apiPost(
    '/Profile/ConfirmBeneficiaryResiliation',
    JSON.stringify({
      otpCode
    }),
    'application/json'
  );
}

export async function apiSendBeneficiaryResiliationRequest(codeTiersBenef, commentaire, dateEffet) {
  return await apiPost(
    '/Profile/SendResiliationBeneficiaryRequest',
    JSON.stringify({
      beneficiaryCodeTiers: codeTiersBenef,
      comment: commentaire,
      dateEffect: dateEffet
    }),
    'application/json'
  );
}

export async function apiUpdatePhone(memberId, code, phone) {
  return await apiPatch(
    `/Members/UpdatePhone/${memberId}/${code}`,
    JSON.stringify({
      phone
    }),
    'application/json'
  );
}
export async function apiUpdateAddress(memberId, code, body) {
  return await apiPatch(
    `/Members/UpdateAddress/${memberId}/${code}`,
    body,
    'form-data'
  );
}
export async function apiUpdateEmail(memberId, code, email) {
  return await apiPatch(
    `/Users/UpdateEmail/${memberId}/${code}`,
    JSON.stringify({
      email
    }),
    'application/json'
  );
}

export async function SendProofOfAddress(memberId, code, attachement) {
  return await apiPatch(
    `/Members/SendProofOfAddress/${memberId}/${code}`,
    attachement,
    'application/json',
    'form-data'
  );
}

export async function apiGetPostalAddressOnly(adress) {
  return await apiGet(
    `/PostalAddress/GetPostalAddressOnly?address=${adress}`,
    'application/json'
  );
}

export async function apiGetMembersLogin(token) {
  try {
    const response = await fetch(API_URL + `/Profile/getProfile`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
        Authorization: 'Bearer ' + token
      }
    });
    const JsonData = await response.json();
    return { ...JsonData, status: response.status };
  } catch (err) {
    return { status: 500 };
  }
}

export async function apiCreateBeneficiary(contractId, body) {
  return await apiPost(
    `/Members/CreateBeneficiary/${contractId}`,
    body,
    '',
    'form-data'
  );
}

export async function apiGetStreetTypeList(token) {
  return await apiGet(`/Profile/GetListTypeVoie`, 'application/json');
}

export async function apiModifyAddress(
  codeAdherent,
  email,
  rue1,
  rue2,
  rue3,
  rue4,
  country,
  city,
  currentPostalCode,
  newPostalCode
) {
  return await apiPost(
    `/Profile/UpdateAddress`,
    JSON.stringify({
      codeTiers: codeAdherent,
      email,
      libelle1: rue1,
      libelle2: rue2,
      libelle3: rue3,
      libelle4: rue4,
      country,
      city,
      actualPostalCode: currentPostalCode,
      newPostalCode
    }),
    'application/json'
  );
}

export async function apiConfirmUpdateAddress(
  codeAdherent,
  email,
  rue1,
  rue2,
  rue3,
  rue4,
  country,
  city,
  currentPostalCode,
  newPostalCode,
  otpCode
) {
  return await apiPost(
    `/Profile/ConfirmUpdateAddress`,
    JSON.stringify({
      codeTiers: codeAdherent,
      email,
      libelle1: rue1,
      libelle2: rue2,
      libelle3: rue3,
      libelle4: rue4,
      country,
      city,
      actualPostalCode: currentPostalCode,
      newPostalCode,
      otpCode
    }),
    'application/json'
  );
}
